const register = () => {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then(registration => {
          if (process.env.REACT_APP_ENV === 'development')
            console.log('Service Worker registered! Scope:', registration.scope)
        })
        .catch(err => {
          if (process.env.REACT_APP_ENV === 'development')
            console.log('Service Worker registration failed:', err)
        })
    })
  }
}

/**
 * Unregister service worker
 * Use this method to unregister service worker if you want to disable service worker caching
 */
const unregister = () => {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        for (const registration of registrations) {
          registration.unregister()
        }
      })
    })
  }
}

export default {
  register,
  unregister,
}
